import React, { Component } from 'react';

import EditAppUploader from './EditAppUploader';
import EditPageContentPrintItem from './EditPageContentPrintItem';

import TOOLS from '../../componentes/TOOLS';

import '../css/EditPageContentPrints.css';

class EditPageContent extends Component {
    constructor() {
        super();
        this.prints= [];

        this.state= {
            prints: []
        };
    }

    checkToken() {
        return new Promise(
            (resolve, reject) => {
                let token = window.localStorage.getItem("AUTH-X-TOKEN");
                resolve(token);
            }
        );
    }

    saveOnServer() {
        const app = this.state;
        const form = new FormData()
        form.append('id', this.props.appId);
        form.append('lang', app.lang);
        form.append('locationId', app.locationId);
        form.append('name', app.name);
        form.append('shortDescription', app.shortDescription);
        form.append('description', app.description);
        form.append('squareBanner', app.squareBanner);
        form.append('wideBanner', app.wideBanner);
        form.append('prints', JSON.stringify(app.prints));
        form.append('News', JSON.stringify(app.prints));
        form.append('Stores', JSON.stringify(app.Stores));

        this.checkToken().then(token => {
            if (token) {
                form.append('AUTH-X-TOKEN', token);

        fetch(`${TOOLS.serverURL}/saveappcontent/`, {
            method: "POST",
            body: form
        })
        .then(response => response.json())
        .then(json => {
            if (json.ok) {
                window.alert("Salvo com sucesso!");
            } else {
                window.alert(json.message);
            }
        });
        } else {
            window.alert("Falha ao recuperar o token");
            return false;
        };
    });
    }

    handleUploadPrint(print) {
        let newPrints= this.prints;
        newPrints.push(print);
        this.prints= newPrints;

        this.props.callBackChangePrints(newPrints);
        //this.setState({prints: newPrints});
    }

    removePrint(print){
        let newPrints= this.prints.filter( p => (p !== print));
        this.prints= newPrints;

        this.props.callBackChangePrints(newPrints);
        //this.setState({prints : newPrints});
    }

    handleRemovePrint(print){
        if(window.confirm("Deseja Excluir a Print?")){
            this.removePrint(print);
        }
        
    }

    componentWillMount() {
        this.prints= this.props.prints;
    }

    render() {
        return (

                <div className="form-container">
                    <label>Capturas de Tela </label>
                    
                    <div id="EditPageContentPrints">
                        {this.props.prints.map(print => <EditPageContentPrintItem print={print} callBackRemovePrint={this.handleRemovePrint.bind(this)} key={print} />)}
                    </div>
                    <EditAppUploader
                        appId={this.props.appId}
                        lang={this.props.lang}
                        typeUpload="print"
                        cssTag="uploader150px"
                        callBackUploadSuccess={this.handleUploadPrint.bind(this)}                        
                    />
                </div>
        );

    }
}

export default EditPageContent;



// WEBPACK FOOTER //
// ./src/adm/componentes/EditPageContentPrints.js